module.exports = __webpack_public_path__ + "static/media/edsansiro-ambientes-003.3a1d3ffd.jpg";